'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("userTaskListPopin", {
  template: require("./userTaskListPopin.html"),
  controller: function controller($scope, userTaskService, $dialogBox) {
    var ctrl = this;
    ctrl.$onInit = function () {
      userTaskService.loadTasksIfRequired();
      userTaskService.reactivePooling();
      $scope.$watch(userTaskService.getCurrentTasks, function (currentTasks) {
        ctrl.tasks = currentTasks;
      });
    };
    ctrl.deleteAllTasks = function () {
      $dialogBox.confirm({
        title: "Suppression des tâches",
        text: "Voulez vous vraiment supprimer toutes les tâches (les rapports ne seront plus disponibles)"
      }).then(function () {
        userTaskService.deleteAllTasks();
      });
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/user-task/userTaskListPopin.js
// module id = 2882
// module chunks = 13